import * as THREE from 'three';
import Time from '../Utils/Time';
import Application from '../Application';
import { heroScreen } from '../World/SceneAnchors';
export class CameraKeyframeInstance {
    constructor(keyframe) {
        this.position = keyframe.position;
        this.focalPoint = keyframe.focalPoint;
    }
    update() { }
}
/**
 * The computers model is roughly 12200 wide, 5300 tall and 8200 deep once
 * scaled, sitting on the ground plane. Everything that frames the whole pile
 * aims here.
 */
const SCENE_FOCUS = new THREE.Vector3(0, 2200, -1500);
const keys = {
    idle: {
        position: new THREE.Vector3(-11000, 8000, 17500),
        focalPoint: new THREE.Vector3(0, 1800, -1500),
    },
    monitor: {
        // Derived from the hero screen every frame, see MonitorKeyframe
        position: new THREE.Vector3(0, 2145, -900),
        focalPoint: new THREE.Vector3(0, 2145, -2430),
    },
    desk: {
        position: new THREE.Vector3(0, 2900, 9500),
        focalPoint: SCENE_FOCUS.clone(),
    },
    loading: {
        position: new THREE.Vector3(-26000, 24000, 26000),
        focalPoint: new THREE.Vector3(0, 0, -1500),
    },
    orbitControlsStart: {
        position: new THREE.Vector3(-10000, 6500, 12500),
        focalPoint: new THREE.Vector3(0, 2000, -1500),
    },
};
/**
 * Frames the hero screen head on. Both the position and the focal point are
 * read off the screen transform that Computers measures at load time, so the
 * zoom follows whichever screen ends up hosting the iframe.
 */
export class MonitorKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.monitor;
        super(keyframe);
        this.application = new Application();
        this.sizes = this.application.sizes;
    }
    update() {
        if (!heroScreen.ready)
            return;
        const aspect = this.sizes.height / this.sizes.width;
        // Pull back further on narrow viewports, and closer on wide ones
        const additionalZoom = this.sizes.width < 768 ? 0 : 0.586;
        const distance = heroScreen.height * (1.704 + aspect * 1.172 - additionalZoom);
        this.focalPoint.copy(heroScreen.position);
        this.position
            .copy(heroScreen.position)
            .addScaledVector(heroScreen.normal, distance);
    }
}
export class LoadingKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.loading;
        super(keyframe);
    }
    update() { }
}
/** How far the camera and its focal point drift with the mouse, in world units */
const DESK_FOCUS_SWAY = new THREE.Vector2(1600, 900);
const DESK_POSITION_SWAY = new THREE.Vector2(1600, 900);
export class DeskKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.desk;
        super(keyframe);
        this.application = new Application();
        this.mouse = this.application.mouse;
        this.sizes = this.application.sizes;
        this.origin = new THREE.Vector3().copy(keyframe.position);
        this.originFocalPoint = new THREE.Vector3().copy(keyframe.focalPoint);
        this.targetFoc = new THREE.Vector3().copy(keyframe.focalPoint);
        this.targetPos = new THREE.Vector3().copy(keyframe.position);
    }
    update() {
        // Mouse position as -1..1 across the viewport
        const nx = (this.mouse.x - this.sizes.width / 2) / (this.sizes.width / 2);
        const ny = (this.mouse.y - this.sizes.height / 2) / (this.sizes.height / 2);
        const focX = this.originFocalPoint.x + nx * DESK_FOCUS_SWAY.x;
        const focY = this.originFocalPoint.y - ny * DESK_FOCUS_SWAY.y;
        const posX = this.origin.x + nx * DESK_POSITION_SWAY.x;
        const posY = this.origin.y - ny * DESK_POSITION_SWAY.y;
        this.targetFoc.x += (focX - this.targetFoc.x) * 0.05;
        this.targetFoc.y += (focY - this.targetFoc.y) * 0.05;
        this.targetPos.x += (posX - this.targetPos.x) * 0.025;
        this.targetPos.y += (posY - this.targetPos.y) * 0.025;
        // Pull back on narrow viewports so the whole pile stays in frame
        const aspect = this.sizes.height / this.sizes.width;
        this.targetPos.z = this.origin.z + aspect * 3000 - 1800;
        this.focalPoint.copy(this.targetFoc);
        this.position.copy(this.targetPos);
    }
}
export class IdleKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.idle;
        super(keyframe);
        this.origin = new THREE.Vector3().copy(keyframe.position);
        this.time = new Time();
    }
    update() {
        this.position.x =
            Math.sin((this.time.elapsed + 19000) * 0.00008) * this.origin.x;
        this.position.y =
            Math.sin((this.time.elapsed + 1000) * 0.000004) * 2500 +
                this.origin.y -
                2000;
    }
}
export class OrbitControlsStart extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.orbitControlsStart;
        super(keyframe);
    }
    update() { }
}
